// نظام الثيمات.
//
// لماذا أُعيد بناؤه: النسخة السابقة كانت سبعة ثيمات كلها بين 3% و6% سطوع
// (أي سوداء فعلياً)، وكل ثيم يحمل ~15 سلسلة Tailwind تُمرَّر يدوياً إلى كل
// مكوّن. تغيير لون واحد كان يعني تعديل سبعة ملفات.
//
// الآن: متغيّرات CSS على :root. المكوّنات تستخدم أسماء دلالية
// (bg-paper، text-ink) ولا تعرف شيئاً عن الثيم المطبَّق.
//
// اللوحة مبنية على ألوان تذهيب المخطوطات الإسلامية — اللازورد والرَّق
// وماء الذهب — لا على الأخضر/الذهبي الذي تتشابه فيه كل تطبيقات القرآن.

/**
 * كل ثيم يعرّف نفس المفاتيح. القيم خام (R G B) لتعمل مع
 * صيغة Tailwind اللونية ‎rgb(var(--x) / <alpha-value>)‎.
 */
export const THEMES = [
  {
    id: 'noor',
    name: 'نور',
    hint: 'لازورد ورَق',
    mode: 'light',
    swatch: ['#FBF7F0', '#2E4B8F', '#B8862F'],
    tokens: {
      paper: '251 247 240',
      surface: '255 253 249',
      surfaceAlt: '244 239 229',
      ink: '27 42 74',
      inkMuted: '107 118 140',
      line: '223 215 200',
      primary: '46 75 143',
      primaryInk: '255 255 255',
      secondary: '184 134 47',
      live: '194 67 46',
      glow: '46 75 143',
    },
  },
  {
    id: 'duha',
    name: 'ضحى',
    hint: 'ضوء الصباح',
    mode: 'light',
    swatch: ['#FFFBF2', '#C2851B', '#7A5B12'],
    tokens: {
      paper: '255 251 242',
      surface: '255 255 252',
      surfaceAlt: '250 242 226',
      ink: '61 46 16',
      inkMuted: '138 119 85',
      line: '235 223 199',
      primary: '194 133 27',
      primaryInk: '40 28 6',
      secondary: '122 91 18',
      live: '190 70 40',
      glow: '236 187 84',
    },
  },
  {
    id: 'sama',
    name: 'سماء',
    hint: 'صفاء نهاري',
    mode: 'light',
    swatch: ['#F4FAFC', '#0E7490', '#0F766E'],
    tokens: {
      paper: '244 250 252',
      surface: '255 255 255',
      surfaceAlt: '229 242 247',
      ink: '12 47 61',
      inkMuted: '92 122 134',
      line: '208 228 236',
      primary: '14 116 144',
      primaryInk: '255 255 255',
      secondary: '15 118 110',
      live: '200 62 62',
      glow: '56 189 213',
    },
  },
  {
    id: 'zaytoon',
    name: 'زيتون',
    hint: 'أخضر هادئ',
    mode: 'light',
    swatch: ['#F7F8F1', '#4A6B3C', '#8A6E2F'],
    tokens: {
      paper: '247 248 241',
      surface: '253 254 249',
      surfaceAlt: '237 240 226',
      ink: '32 43 26',
      inkMuted: '106 117 96',
      line: '218 224 203',
      primary: '74 107 60',
      primaryInk: '255 255 255',
      secondary: '138 110 47',
      live: '186 71 48',
      glow: '124 160 96',
    },
  },
  {
    id: 'ward',
    name: 'ورد',
    hint: 'دافئ وردي',
    mode: 'light',
    swatch: ['#FDF6F5', '#9C3B52', '#7A4B86'],
    tokens: {
      paper: '253 246 245',
      surface: '255 252 251',
      surfaceAlt: '248 234 233',
      ink: '58 28 35',
      inkMuted: '134 104 110',
      line: '235 216 215',
      primary: '156 59 82',
      primaryInk: '255 255 255',
      secondary: '122 75 134',
      live: '183 58 58',
      glow: '212 132 152',
    },
  },
  {
    id: 'layl',
    name: 'ليل',
    hint: 'نيلي للقراءة ليلاً',
    mode: 'dark',
    swatch: ['#121A2E', '#8AA7E8', '#D8B45C'],
    tokens: {
      paper: '18 26 46',
      surface: '26 36 60',
      surfaceAlt: '35 47 76',
      ink: '226 232 245',
      inkMuted: '148 161 189',
      line: '48 62 94',
      primary: '138 167 232',
      primaryInk: '15 22 40',
      secondary: '216 180 92',
      live: '232 106 92',
      glow: '92 124 200',
    },
  },
  {
    id: 'mihrab',
    name: 'محراب',
    hint: 'بنّي دافئ وذهب',
    mode: 'dark',
    swatch: ['#1E1710', '#D9A441', '#9AB08A'],
    tokens: {
      paper: '30 23 16',
      surface: '43 33 23',
      surfaceAlt: '56 43 30',
      ink: '241 234 222',
      inkMuted: '177 163 143',
      line: '74 58 41',
      primary: '217 164 65',
      primaryInk: '34 25 14',
      secondary: '154 176 138',
      live: '224 106 84',
      glow: '180 132 56',
    },
  },
];

export const DEFAULT_THEME_ID = 'noor';

export const findTheme = (id) => THEMES.find((t) => t.id === id) ?? THEMES[0];

/**
 * الثيم التلقائي: يتبع وقت الصلاة الحالي.
 *
 * هذا هو سبب وجود نظام الثيمات أصلاً — اللون يخبرك أين أنت من اليوم،
 * فالتطبيق يشرق مع الضحى ويهدأ مع العشاء دون أن تلمس شيئاً.
 */
export const THEME_BY_PRAYER = {
  fajr: 'sama',
  sunrise: 'duha',
  dhuhr: 'noor',
  asr: 'duha',
  maghrib: 'ward',
  isha: 'layl',
  none: 'layl',
};

/**
 * يحدد الثيم التلقائي المناسب بناءً على الصلاة الحالية أو ساعة اليوم.
 */
export function getAutoThemeId(prayerPeriod) {
  if (prayerPeriod && THEME_BY_PRAYER[prayerPeriod]) {
    return THEME_BY_PRAYER[prayerPeriod];
  }
  const h = new Date().getHours();
  if (h >= 4 && h < 6) return 'sama';
  if (h >= 6 && h < 11) return 'duha';
  if (h >= 11 && h < 15) return 'noor';
  if (h >= 15 && h < 18) return 'duha';
  if (h >= 18 && h < 20) return 'ward';
  return 'layl';
}

/**
 * جدول الثيم التلقائي: متى يبدأ كل ثيم في الأمس واليوم والغد.
 *
 * الإقلاع لا ينتظر حساب المواقيت: سكربت index.html وأندرويد يقرآن هذا
 * الجدول فيعرفان ثيم اللحظة الحاضرة. كانا يعرضان آخر ثيم رُئي في الجلسة
 * السابقة، فإن تغيّر وقت الصلاة منذها ومض الثيم القديم ثم تبدّل.
 *
 * @param {Array<Record<string, Date>>} days مواقيت الأمس واليوم والغد
 * @returns {Array<[number, string, string, string]>} [بداية, معرّف, لون الورق, الوضع]
 */
export function buildThemeSchedule(days) {
  const keys = ['fajr', 'sunrise', 'dhuhr', 'asr', 'maghrib', 'isha'];
  const entries = [];
  days.forEach((times, dayIndex) => {
    keys.forEach((key) => {
      // من الأمس يكفي العشاء: هو ثيم ما قبل فجر اليوم
      if (dayIndex === 0 && key !== 'isha') return;
      const at = times?.[key];
      if (!(at instanceof Date) || Number.isNaN(at.getTime())) return;
      const theme = findTheme(THEME_BY_PRAYER[key]);
      entries.push([at.getTime(), theme.id, paperHex(theme), theme.mode]);
    });
  });
  return entries.sort((a, b) => a[0] - b[0]);
}

function paperHex(theme) {
  return `#${theme.tokens.paper
    .split(' ')
    .map((n) => Number(n).toString(16).padStart(2, '0'))
    .join('')}`;
}

/** يطبّق رموز الثيم على عنصر الجذر. */
export function applyTheme(theme) {
  const root = document.documentElement;
  Object.entries(theme.tokens).forEach(([key, value]) => {
    root.style.setProperty(`--c-${key}`, value);
  });
  root.dataset.mode = theme.mode;
  root.dataset.theme = theme.id;
  root.style.backgroundColor = `rgb(${theme.tokens.paper})`;
  root.style.color = `rgb(${theme.tokens.ink})`;

  try {
    localStorage.setItem('moslam_theme_active', theme.id);
  } catch {}

  // لون شريط المتصفح/النظام يتبع الورق
  const meta = document.querySelector('meta[name="theme-color"]');
  if (meta) meta.setAttribute('content', `rgb(${theme.tokens.paper})`);
}
